import React from "react"
import cx from "classnames"

import DefaultButton from "../Buttons/DefaultButton"

type HelperPropsType = {
  children?: React.ReactNode
  className?: string
  title: string
  titleClassName?: string
  contentClassName?: string
  cta?: ReturnType<typeof DefaultButton | typeof DefaultButton.Link>
}

const Helper = ({
  className,
  titleClassName,
  contentClassName,
  title,
  children,
  cta,
}: HelperPropsType) => (
  <div className={cx("cobalt-helper", className)}>
    <strong className={cx("cobalt-helper__title", titleClassName)}>
      {title}
    </strong>
    <div className={cx("cobalt-helper__content", contentClassName)}>
      {children}
    </div>
    {cta}
  </div>
)

export default Helper
